export default __webpack_public_path__ + "static/media/Circus Knives.2c3fd4fe.png";